import {css, FlattenSimpleInterpolation} from 'styled-components'

export const normalizeHexColor = (hexColor: string): string | FlattenSimpleInterpolation => {
  if (hexColor.length === 4) {
    return css`#${hexColor[1]}${hexColor[1]}${hexColor[2]}${hexColor[2]}${hexColor[3]}${hexColor[3]}`
  }
  return hexColor
}

export const hexToRgba = (hexColor: string, opacity = 1): string | FlattenSimpleInterpolation => {
  // @ts-expect-error type not generated properly
  const v = normalizeHexColor(hexColor).substring(1)
  const parts = v.match(/.{2}/g)?.map((p: string) => parseInt(p, 16)) ?? [255, 255, 255]
  if (parts.length === 3 && opacity === 100) {
    return css`rgb(${parts.join(',')})`
  }
  if (parts.length === 3) {
    parts.push(opacity)
  }
  return css`rgba(${parts.join(',')})`
}
